import UserActionTypes from './user.types';

export const setCurrentUser = (user) => ({
  type: UserActionTypes.SET_CURRENT_USER,
  payload: user,
});

export const setCurrentUserRole = (role) => ({
  type: UserActionTypes.SET_CURRENT_USER_ROLE,
  payload: role,
});

export const signInStart = () => ({
  type: UserActionTypes.SIGN_IN_START,
});

export const signInSuccess = (userAndRole) => {
  // socket.connect();
  return {
    type: UserActionTypes.SIGN_IN_SUCCESS,
    payload: userAndRole,
  };
};

export const signInFaliure = (error) => ({
  type: UserActionTypes.SIGN_IN_FAILURE,
  payload: error,
});

export const checkUserSession = () => ({
  type: UserActionTypes.CHECK_USER_SESSION,
});

export const signOutStart = () => ({
  type: UserActionTypes.SIGN_OUT_START,
  payload: null,
});

export const signOutSuccess = () => {
  // socket.disconnect();
  return {
    type: UserActionTypes.SIGN_OUT_SUCCESS,
  };
};

export const signOutFailure = (error) => ({
  type: UserActionTypes.SIGN_OUT_FAILURE,
  payload: error,
});

export const microsoftSignInStart = () => ({
  type: UserActionTypes.MICROSOFT_SIGN_IN_START,
});
